module.exports = (__webpack_require__(1))(103);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/widgets/BrowserWidget.js from dll-reference girder_lib
// module id = 17
// module chunks = 0